<template>
  <h2>Platnost odkazu vypršela</h2>
</template>

<script>
export default {
  name: 'InvalidSignature'
}
</script>

<style scoped>

</style>
